import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import {
    Activity,
    BarChart2,
    DollarSign,
    Map,
    Pocket,
    RefreshCcw,
    ShoppingBag,
    TrendingDown,
    TrendingUp,
    Truck,
    Users,
} from 'react-feather';
import { Calendar } from 'react-modern-calendar-datepicker';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { Bar, Doughnut, Line } from 'react-chartjs-2';
import { bars, line, doughnut } from './../variables/charts';

import product1 from './../assets/images/products/01.jpg';
import product2 from './../assets/images/products/02.jpg';
import product3 from './../assets/images/products/03.jpg';
import product4 from './../assets/images/products/04.jpg';
import product5 from './../assets/images/products/05.jpg';
import product6 from './../assets/images/products/06.jpg';
import product7 from './../assets/images/products/07.jpg';
import product8 from './../assets/images/products/08.jpg';
import product9 from './../assets/images/products/09.jpg';
import product10 from './../assets/images/products/10.jpg';
import product11 from './../assets/images/products/11.jpg';
import product12 from './../assets/images/products/12.jpg';
import { Card, Col, Container, Row } from 'react-bootstrap';

export default function Main() {
    const [selectedDay, setSelectedDay] = useState(null);

    return (
        <>
            <Container fluid>
                <Col>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>داشبورد</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>داشبورد</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </Col>

                <div className='space-20' />

                <Row>
                    <Col sm={12} md={6} xl={3} className='mb-4'>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col xs={7}>
                                        <p className='text-muted'>
                                            سفارشات ارسال شده
                                        </p>

                                        <h6>32</h6>
                                    </Col>

                                    <Col xs={5}>
                                        <div className='card-icon gr-blue text-white'>
                                            <ShoppingBag />
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col sm={12} md={6} xl={3} className='mb-4'>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col xs={7}>
                                        <p className='text-muted'>
                                            سفارشات تاییده نشده
                                        </p>

                                        <h6>16</h6>
                                    </Col>

                                    <Col xs={5}>
                                        <div className='card-icon gr-red text-white'>
                                            <Pocket />
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col sm={12} md={6} xl={3} className='mb-4'>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col xs={7}>
                                        <p className='text-muted'>
                                            تعداد مشتری ها
                                        </p>

                                        <h6>124</h6>
                                    </Col>

                                    <Col xs={5}>
                                        <div className='card-icon gr-green text-white'>
                                            <Users />
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col sm={12} md={6} xl={3} className='mb-4'>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col xs={7}>
                                        <p className='text-muted'>
                                            درآمد ماهیانه
                                        </p>

                                        <h6>4،500،000 تومان</h6>
                                    </Col>

                                    <Col xs={5}>
                                        <div className='card-icon gr-purple text-white'>
                                            <DollarSign />
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <div className='col-md-12 col-lg-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                <TrendingDown
                                    className='text-danger mr-2'
                                    size={15}
                                />
                                آمار خرید و فروش محصولات
                                <Link to='#'>
                                    <RefreshCcw
                                        className='float-start'
                                        size={15}
                                    />
                                </Link>
                            </div>

                            <div className='card-body height-40vh'>
                                <Bar data={bars} options={bars.options} />
                            </div>
                        </Card>
                    </div>

                    <div className='col-md-12 col-lg-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                <TrendingUp
                                    className='text-success mr-2'
                                    size={15}
                                />
                                درآمد ماهیانه
                                <Link to='#'>
                                    <RefreshCcw
                                        className='float-start'
                                        size={15}
                                    />
                                </Link>
                            </div>

                            <div className='card-body height-40vh'>
                                <Line data={line} options={line.options} />
                            </div>
                        </Card>
                    </div>
                </Row>

                <Row>
                    <div className='col-12 mb-4'>
                        <Card style={{ height: '50vh' }}>
                            <div className='card-title bg-transparent p-3'>
                                <Truck className='mr-2' size={15} />
                                مشخصات و وضعیت محصولات
                                <Link to='#'>
                                    <RefreshCcw
                                        className='float-start'
                                        size={15}
                                    />
                                </Link>
                            </div>

                            <div className='card-body scrolled height-43vh'>
                                <ul className='responsive-table'>
                                    <li className='table-header'>
                                        <div className='col-1'>نام مشتری</div>

                                        <div className='col-1'>کد محصول</div>

                                        <div className='col-1'>نام محصول</div>

                                        <div className='col-1'>قیمت خرید</div>

                                        <div className='col-1'>شهر</div>

                                        <div className='col-1'>وضعیت ارسال</div>
                                    </li>

                                    <li className='table-row'>
                                        <div
                                            className='col col-1'
                                            data-label='نام مشتری'
                                        >
                                            امیررضا کدخدازاده
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='کد محصول'
                                        >
                                            42235
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='نام محصول'
                                        >
                                            تی شرت
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='مبلغ خرید'
                                        >
                                            350،000 تومان
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='شهر'
                                        >
                                            کرج
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='وضعیت ارسال'
                                        >
                                            <span className='badge badge-success'>
                                                ارسال شد
                                            </span>
                                        </div>
                                    </li>

                                    <li className='table-row'>
                                        <div
                                            className='col col-1'
                                            data-label='نام مشتری'
                                        >
                                            امیررضا کدخدازاده
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='کد محصول'
                                        >
                                            42235
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='نام محصول'
                                        >
                                            تی شرت
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='مبلغ خرید'
                                        >
                                            350،000 تومان
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='شهر'
                                        >
                                            کرج
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='وضعیت ارسال'
                                        >
                                            <span className='badge badge-danger'>
                                                کنسل شد
                                            </span>
                                        </div>
                                    </li>

                                    <li className='table-row'>
                                        <div
                                            className='col col-1'
                                            data-label='نام مشتری'
                                        >
                                            امیررضا کدخدازاده
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='کد محصول'
                                        >
                                            42235
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='نام محصول'
                                        >
                                            تی شرت
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='مبلغ خرید'
                                        >
                                            350،000 تومان
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='شهر'
                                        >
                                            کرج
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='وضعیت ارسال'
                                        >
                                            <span className='badge badge-warning'>
                                                در انتظار تایید
                                            </span>
                                        </div>
                                    </li>

                                    <li className='table-row'>
                                        <div
                                            className='col col-1'
                                            data-label='نام مشتری'
                                        >
                                            امیررضا کدخدازاده
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='کد محصول'
                                        >
                                            42235
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='نام محصول'
                                        >
                                            تی شرت
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='مبلغ خرید'
                                        >
                                            350،000 تومان
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='شهر'
                                        >
                                            کرج
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='وضعیت ارسال'
                                        >
                                            <span className='badge badge-info'>
                                                در حال ارسال
                                            </span>
                                        </div>
                                    </li>

                                    <li className='table-row'>
                                        <div
                                            className='col col-1'
                                            data-label='نام مشتری'
                                        >
                                            امیررضا کدخدازاده
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='کد محصول'
                                        >
                                            42235
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='نام محصول'
                                        >
                                            تی شرت
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='مبلغ خرید'
                                        >
                                            350،000 تومان
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='شهر'
                                        >
                                            کرج
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='وضعیت ارسال'
                                        >
                                            <span className='badge badge-danger'>
                                                کنسل شد
                                            </span>
                                        </div>
                                    </li>

                                    <li className='table-row'>
                                        <div
                                            className='col col-1'
                                            data-label='نام مشتری'
                                        >
                                            امیررضا کدخدازاده
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='کد محصول'
                                        >
                                            42235
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='نام محصول'
                                        >
                                            تی شرت
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='مبلغ خرید'
                                        >
                                            350،000 تومان
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='شهر'
                                        >
                                            کرج
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='وضعیت ارسال'
                                        >
                                            <span className='badge badge-warning'>
                                                در انتظار تایید
                                            </span>
                                        </div>
                                    </li>

                                    <li className='table-row'>
                                        <div
                                            className='col col-1'
                                            data-label='نام مشتری'
                                        >
                                            امیررضا کدخدازاده
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='کد محصول'
                                        >
                                            42235
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='نام محصول'
                                        >
                                            تی شرت
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='مبلغ خرید'
                                        >
                                            350،000 تومان
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='شهر'
                                        >
                                            کرج
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='وضعیت ارسال'
                                        >
                                            <span className='badge badge-success'>
                                                ارسال شد
                                            </span>
                                        </div>
                                    </li>

                                    <li className='table-row'>
                                        <div
                                            className='col col-1'
                                            data-label='نام مشتری'
                                        >
                                            امیررضا کدخدازاده
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='کد محصول'
                                        >
                                            42235
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='نام محصول'
                                        >
                                            تی شرت
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='مبلغ خرید'
                                        >
                                            350،000 تومان
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='شهر'
                                        >
                                            کرج
                                        </div>

                                        <div
                                            className='col col-1'
                                            data-label='وضعیت ارسال'
                                        >
                                            <span className='badge badge-info'>
                                                در حال ارسال
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Card>
                    </div>
                </Row>

                <Row>
                    <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
                        <Card>
                            <Card.Body>
                                <Calendar
                                    value={selectedDay}
                                    onChange={setSelectedDay}
                                    shouldHighlightWeekends
                                    locale='fa'
                                />
                            </Card.Body>
                        </Card>
                    </div>

                    <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                <BarChart2 className='mr-2' size={15} />
                                آمار کل
                                <Link to='#'>
                                    <RefreshCcw
                                        className='float-start'
                                        size={15}
                                    />
                                </Link>
                            </div>

                            <div className='card-body height-40vh'>
                                <Doughnut
                                    data={doughnut}
                                    options={doughnut.options}
                                />
                            </div>
                        </Card>
                    </div>

                    <div className='col-md-12 col-lg-4 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                <Activity className='mr-2' size={15} />
                                فعالیت های اخیر
                                <Link to='#'>
                                    <RefreshCcw
                                        className='float-start'
                                        size={15}
                                    />
                                </Link>
                            </div>

                            <div className='card-body height-40vh'>
                                <div className='timeline scrolled'>
                                    <div className='timeline-item'>
                                        <div className='timeline-dot border-warning' />

                                        <div className='timeline-content'>
                                            <div>شما یک پیام جدید داری</div>

                                            <div className='timeline-date'>
                                                10 دقیقه پیش
                                            </div>
                                        </div>
                                    </div>

                                    <div className='timeline-item'>
                                        <div className='timeline-dot border-primary' />

                                        <div className='timeline-content'>
                                            <div>
                                                محصول جدید به اسم قهوه ساز خانگی
                                                به محصولات اضافه شد
                                            </div>

                                            <div className='timeline-date'>
                                                ۴۵ دقیقه پیش
                                            </div>
                                        </div>
                                    </div>

                                    <div className='timeline-item'>
                                        <div className='timeline-dot border-danger' />

                                        <div className='timeline-content'>
                                            <div>
                                                محصول جدید برای ارسال منتظر
                                                تایید شماست!
                                            </div>

                                            <div className='timeline-date'>
                                                1 ساعت پیش
                                            </div>
                                        </div>
                                    </div>

                                    <div className='timeline-item'>
                                        <div className='timeline-dot border-danger' />

                                        <div className='timeline-content'>
                                            <div>
                                                لطفا جهت بازگشت وجه مشتری اقدام
                                                کنید
                                            </div>

                                            <div className='timeline-date'>
                                                1 ساعت پیش
                                            </div>
                                        </div>
                                    </div>

                                    <div className='timeline-item'>
                                        <div className='timeline-dot border-success' />

                                        <div className='timeline-content'>
                                            <div>
                                                محصول ۱۰۰۹۴۶/ با موفقیت ارسال
                                                شد.
                                            </div>

                                            <div className='timeline-date'>
                                                ۳ هقته پیش
                                            </div>
                                        </div>
                                    </div>

                                    <div className='timeline-item'>
                                        <div className='timeline-dot border-warning' />

                                        <div className='timeline-content'>
                                            <div>شما یک کامنت جدید دارید</div>

                                            <div className='timeline-date'>
                                                3 روز پیش
                                            </div>
                                        </div>
                                    </div>

                                    <div className='timeline-item'>
                                        <div className='timeline-dot border-primary' />

                                        <div className='timeline-content'>
                                            <div>
                                                محصول جدید به اسم لباس زنانه به
                                                محصولات اضافه شد
                                            </div>

                                            <div className='timeline-date'>
                                                4 روز پیش
                                            </div>
                                        </div>
                                    </div>

                                    <div className='timeline-item'>
                                        <div className='timeline-dot border-primary' />

                                        <div className='timeline-content'>
                                            <div>
                                                محصول جدید به اسم کت شلوار
                                                مردانه به محصولات اضافه شد
                                            </div>

                                            <div className='timeline-date'>
                                                5 روز پیش
                                            </div>
                                        </div>
                                    </div>

                                    <div className='timeline-item'>
                                        <div className='timeline-dot border-success' />

                                        <div className='timeline-content'>
                                            <div>
                                                محصول ۱۰۰۹۴۶/ با موفقیت ارسال
                                                شد.
                                            </div>

                                            <div className='timeline-date'>
                                                ۳ هقته پیش
                                            </div>
                                        </div>
                                    </div>

                                    <div className='timeline-item'>
                                        <div className='timeline-dot border-warning' />

                                        <div className='timeline-content'>
                                            <div>شما یک پیام جدید داری</div>

                                            <div className='timeline-date'>
                                                ۲ ماه پیش
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                </Row>

                <Row>
                    <div className='col-md-12 col-lg-3 col-xl-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                <ShoppingBag className='mr-2' size={15} />
                                آخرین محصولات فروخته شده
                                <Link to='#'>
                                    <RefreshCcw
                                        className='float-start'
                                        size={15}
                                    />
                                </Link>
                            </div>

                            <div className='card-body scrolled height-40vh'>
                                <div className='recent-orders mb-3'>
                                    <Link to='#'>
                                        <img
                                            src={product1}
                                            alt='آخرین محصولات فروخته شده'
                                        />
                                    </Link>

                                    <div className='pl-3 pr-2 pb-2'>
                                        <Link to='#'>
                                            <p>پنیر محلی</p>

                                            <p className='address'>
                                                آدرس : تهران، اتوبان امام علی،
                                                بعد از میدان سوم، خیابان مطهری،
                                                کوچه ایکس، پلاک ایگرگ، ساختمان
                                                زد، زنگ ایکس
                                            </p>

                                            <div className='date'>
                                                در تاریخ : ۳ اردبیهشت 1400
                                            </div>
                                        </Link>
                                    </div>
                                </div>

                                <div className='recent-orders mb-3'>
                                    <Link to='#'>
                                        <img
                                            src={product2}
                                            alt='آخرین محصولات فروخته شده'
                                        />
                                    </Link>

                                    <div className='pl-3 pr-2 pb-2'>
                                        <Link to='#'>
                                            <p>نوشابه</p>

                                            <p className='address'>
                                                آدرس : تهران، اتوبان امام علی،
                                                بعد از میدان سوم، خیابان مطهری،
                                                کوچه ایکس، پلاک ایگرگ، ساختمان
                                                زد، زنگ ایکس
                                            </p>

                                            <div className='date'>
                                                در تاریخ : ۳ اردبیهشت 1400
                                            </div>
                                        </Link>
                                    </div>
                                </div>

                                <div className='recent-orders mb-3'>
                                    <Link to='#'>
                                        <img
                                            src={product3}
                                            alt='آخرین محصولات فروخته شده'
                                        />
                                    </Link>

                                    <div className='pl-3 pr-2 pb-2'>
                                        <Link to='#'>
                                            <p>شامپو زنانه</p>

                                            <p className='address'>
                                                آدرس : تهران، اتوبان امام علی،
                                                بعد از میدان سوم، خیابان مطهری،
                                                کوچه ایکس، پلاک ایگرگ، ساختمان
                                                زد، زنگ ایکس
                                            </p>

                                            <div className='date'>
                                                در تاریخ : ۳ اردبیهشت 1400
                                            </div>
                                        </Link>
                                    </div>
                                </div>

                                <div className='recent-orders mb-3'>
                                    <Link to='#'>
                                        <img
                                            src={product4}
                                            alt='آخرین محصولات فروخته شده'
                                        />
                                    </Link>

                                    <div className='pl-3 pr-2 pb-2'>
                                        <Link to='#'>
                                            <p>نون شکلات صبحانه</p>

                                            <p className='address'>
                                                آدرس : تهران، اتوبان امام علی،
                                                بعد از میدان سوم، خیابان مطهری،
                                                کوچه ایکس، پلاک ایگرگ، ساختمان
                                                زد، زنگ ایکس
                                            </p>

                                            <div className='date'>
                                                در تاریخ : ۳ اردبیهشت 1400
                                            </div>
                                        </Link>
                                    </div>
                                </div>

                                <div className='recent-orders mb-3'>
                                    <Link to='#'>
                                        <img
                                            src={product5}
                                            alt='آخرین محصولات فروخته شده'
                                        />
                                    </Link>

                                    <div className='pl-3 pr-2 pb-2'>
                                        <Link to='#'>
                                            <p>مرغ ۲ کیلویی</p>

                                            <p className='address'>
                                                آدرس : تهران، اتوبان امام علی،
                                                بعد از میدان سوم، خیابان مطهری،
                                                کوچه ایکس، پلاک ایگرگ، ساختمان
                                                زد، زنگ ایکس
                                            </p>

                                            <div className='date'>
                                                در تاریخ : ۳ اردبیهشت 1400
                                            </div>
                                        </Link>
                                    </div>
                                </div>

                                <div className='recent-orders mb-3'>
                                    <Link to='#'>
                                        <img
                                            src={product6}
                                            alt='آخرین محصولات فروخته شده'
                                        />
                                    </Link>

                                    <div className='pl-3 pr-2 pb-2'>
                                        <Link to='#'>
                                            <p>روغن زیتون</p>

                                            <p className='address'>
                                                آدرس : تهران، اتوبان امام علی،
                                                بعد از میدان سوم، خیابان مطهری،
                                                کوچه ایکس، پلاک ایگرگ، ساختمان
                                                زد، زنگ ایکس
                                            </p>

                                            <div className='date'>
                                                در تاریخ : ۳ اردبیهشت 1400
                                            </div>
                                        </Link>
                                    </div>
                                </div>

                                <div className='recent-orders mb-3'>
                                    <Link to='#'>
                                        <img
                                            src={product7}
                                            alt='آخرین محصولات فروخته شده'
                                        />
                                    </Link>

                                    <div className='pl-3 pr-2 pb-2'>
                                        <Link to='#'>
                                            <p>هدفون بی سیم</p>

                                            <p className='address'>
                                                آدرس : تهران، اتوبان امام علی،
                                                بعد از میدان سوم، خیابان مطهری،
                                                کوچه ایکس، پلاک ایگرگ، ساختمان
                                                زد، زنگ ایکس
                                            </p>

                                            <div className='date'>
                                                در تاریخ : ۳ اردبیهشت 1400
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div className='col-md-12 col-lg-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                <DollarSign className='mr-2' size={15} />
                                پر فروش ترین محصولات
                                <Link to='#'>
                                    <RefreshCcw
                                        className='float-start'
                                        size={15}
                                    />
                                </Link>
                            </div>

                            <div className='card-body scrolled height-40vh'>
                                <div className='table-responsive'>
                                    <table className='table table-bordered table-striped table-product'>
                                        <thead>
                                            <tr>
                                                <th scope='col'>نام محصول</th>

                                                <th scope='col'>قیمت محصول</th>

                                                <th scope='col'>تخفیف</th>

                                                <th scope='col'>تعداد فروش</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>
                                                    <img
                                                        src={product8}
                                                        alt='user'
                                                    />
                                                    تلویزیون هوشمند
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product9}
                                                        alt='user'
                                                    />
                                                    اسپیکر بی سیم
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product10}
                                                        alt='user'
                                                    />
                                                    ساعت هوشمند
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product11}
                                                        alt='user'
                                                    />
                                                    سویشرت
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product12}
                                                        alt='user'
                                                    />
                                                    عینک آفتابی
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Card>
                    </div>
                </Row>

                <Row>
                    <div className='col-12'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                <Map className='mr-2' size={15} />
                                نقشه تهران بزرگ
                            </div>
                            <div className='card-body height-43vh'>
                                <MapContainer
                                    center={[35.701208, 51.386186, 16]}
                                    zoom={10}
                                    scrollWheelZoom={false}
                                >
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, '
                                        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                                    />
                                    <Marker
                                        position={[35.701208, 51.386186, 16]}
                                    >
                                        <Popup>
                                            نقشه تهران بزرگ <br /> این فقط یک
                                            نمونه برای زیبایی ست
                                        </Popup>
                                    </Marker>
                                </MapContainer>
                            </div>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
}
